@if (data(); as data) {
  @if (isPending()) {
    <div class="proposed-action">
      <div class="proposed-action__function">
        <button type="button" class="proposed-action__function-chip" (click)="openArguments()">
          {{ data.functionId }}
        </button>
      </div>

      <div class="proposed-action__chips">
        <button type="button" class="proposed-action__chip" [disabled]="actionInProgress()" (click)="onApprove()">
          {{ data.approveText || ('AI_ASSISTANT.PROPOSED_ACTION.YES' | translate) }}
        </button>
        <button type="button" class="proposed-action__chip" [disabled]="actionInProgress()" (click)="onReject()">
          {{ 'AI_ASSISTANT.PROPOSED_ACTION.NO' | translate }}
        </button>
        <button
          type="button"
          class="proposed-action__chip"
          [class.proposed-action__chip--selected]="changeSelected()"
          [disabled]="actionInProgress()"
          (click)="onChangeSomething()"
        >
          {{ 'AI_ASSISTANT.PROPOSED_ACTION.CHANGE_SOMETHING' | translate }}
        </button>
      </div>
    </div>
  }

  @if (statusLabel(); as label) {
    <glxy-badge color="grey" class="proposed-action__status-badge">
      <mat-icon class="proposed-action__status-icon">{{ statusIcon() }}</mat-icon>
      {{ data.functionId }} {{ label | translate }}
    </glxy-badge>
  }
}
